import { mergeDeep } from '@ngx-translate/core';
import type { Translation } from '@larscom/ngx-translate-module-loader';

/** Keep app-owned card labels authoritative while retaining ECM labels elsewhere. */
export function mergeAppTranslations(translations: Translation[]) {
  const merged = translations.reduce<Record<string, unknown>>(
    (result, translation) => mergeDeep(result, translation),
    {}
  );
  const bundled = (translations[0] ?? {}) as Record<string, unknown>;
  for (const namespace of ['vehicleParking', 'residentCardFilters']) {
    if (bundled[namespace]) merged[namespace] = bundled[namespace];
  }
  return merged;
}
